import { ScaleElement } from '@scale/base-element';
import { Events } from '@scale/events';
import { parseUtcOffset, shopWallClock } from '@scale/utilities';

class DeliveryEstimation extends ScaleElement {
  setup() {
    this.#calculate();
    this.onDocument(Events.VARIANT_SELECTED, (e) => {
      this.hidden = !e.variant?.available;
      if (e.variant?.available) this.#calculate();
    });
  }

  #calculate() {
    const minDays = this.getNumber('data-min-days', 3);
    const maxDays = this.getNumber('data-max-days', 7);
    const cutoffAttribute = Number(this.getAttribute('data-cutoff-hour'));
    const cutoff = Number.isFinite(cutoffAttribute) ? cutoffAttribute : 14;
    const excludeWeekends = this.getBoolean('data-exclude-weekends');
    const format = this.getAttribute('data-date-format') || 'short';

    const offsetMinutes = parseUtcOffset(this.getAttribute('data-utc-offset'));
    if (offsetMinutes === null) {
      if (!this.hasAttribute('data-visual-preview-mode')) this.hidden = true;
      return;
    }

    const now = shopWallClock(offsetMinutes);
    const startTomorrow = now.getUTCHours() >= cutoff;
    const start = startTomorrow ? 1 : 0;

    const minDate = this.#addBusinessDays(now, minDays + start, excludeWeekends);
    const maxDate = this.#addBusinessDays(now, maxDays + start, excludeWeekends);

    const dateEl = this.ref('date');
    if (dateEl) {
      dateEl.textContent = minDays === maxDays
        ? this.#formatDate(minDate, format)
        : `${this.#formatDate(minDate, format)} - ${this.#formatDate(maxDate, format)}`;
    }
  }

  #addBusinessDays(start, days, excludeWeekends) {
    const date = new Date(start);
    let added = 0;
    while (added < days) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (excludeWeekends && (date.getUTCDay() === 0 || date.getUTCDay() === 6)) continue;
      added++;
    }
    return date;
  }

  #formatDate(date, format) {
    const locale = document.documentElement.lang || 'en';
    switch (format) {
      case 'long':
        return date.toLocaleDateString(locale, { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' });
      case 'numeric':
        return date.toLocaleDateString(locale, { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'UTC' });
      default:
        return date.toLocaleDateString(locale, { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
    }
  }
}

if (!customElements.get('delivery-estimation')) {
  customElements.define('delivery-estimation', DeliveryEstimation);
}
